import { DEFAULT_FORM_SUBTITLE } from '../../../utils/formPromoConfig';

// Which action the secondary button performs.
// - question: hands off to the self-schedule app's Ask a Question screen (default).
// - quote:    stashes the contact fields and sends the visitor to the legacy
//             Custom Quote form, the same path ConsultationForm's "Get A Custom
//             Quote" takes on /lp/google-v2 (WEBDEV-4259).
export const SECONDARY_CTA = {
    question: 'question',
    quote: 'quote',
} as const;
export type SecondaryCta = (typeof SECONDARY_CTA)[keyof typeof SECONDARY_CTA];

// Where the quote CTA sends the visitor today. The estimate page pre-fills its
// form from the localStorage record handleFormNavigation writes (see
// useFormPrePopulation), so nothing on /specials/estimate had to change. Once the
// Custom Quote form is rebuilt inside the self-schedule app this becomes a
// handoff (writeOnPageHandoff with a quote intent) instead of a page navigation —
// swap the branch in OnPageSelfScheduleForm's handleSubmit, not the callers.
export const CUSTOM_QUOTE_PATH = '/specials/estimate';

export interface OnPageSelfScheduleConfig {
    title: string;
    subtitle: string;
    secondaryCta: SecondaryCta;
    buttonLabels: {
        schedule: string;
        inquiry: string;
    };
}

export const defaultOnPageSelfScheduleConfig: OnPageSelfScheduleConfig = {
    title: 'Get Started',
    subtitle: DEFAULT_FORM_SUBTITLE,
    secondaryCta: SECONDARY_CTA.question,
    buttonLabels: {
        schedule: 'See Available Times',
        inquiry: 'Ask A Question',
    },
};

// Google LP placement: matches the labels of the legacy consultWithCustomQuoteConfig
// that page used before the self-schedule variant replaced its form.
export const customQuoteOnPageSelfScheduleConfig: OnPageSelfScheduleConfig = {
    ...defaultOnPageSelfScheduleConfig,
    secondaryCta: SECONDARY_CTA.quote,
    buttonLabels: {
        schedule: 'See Available Times',
        inquiry: 'Get A Custom Quote',
    },
};
